/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ClothesOuterTshirtIcon24Solid = forwardRef('ClothesOuterTshirtIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8 2a1 1 0 0 1 1 1 3 3 0 1 0 6 0 1 1 0 0 1 1-1c1.534 0 2.983.563 3.997 1.746l3.608 4.21a1.4 1.4 0 0 1-.133 1.958l-2.418 2.149c-.635.565-1.525.399-2.054-.206V18.5a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 5 18.5v-6.643c-.53.605-1.419.77-2.055.206L.528 9.913a1.4 1.4 0 0 1-.133-1.957l3.608-4.21C5.017 2.563 6.466 2 8 2Z" })));
});
